import React from 'react'
import WidgetSelector from './WidgetSelector'

export default function WidgetVehicleSelector({
  value,
  displayValue,
  vehicles,
  onChange,
  viewOnly,
  reloadDropdownData,
  size,
}) {
  return (
    <React.Fragment>
      <WidgetSelector
        viewOnly={viewOnly || false}
        selectedValue={value}
        displayValue={displayValue}
        options={vehicles}
        onChange={(values) => onChange(values)}
        reloadDropdownData={() => reloadDropdownData()}
        placeHolder="Select Vehicle No."
        showCloudIcon={true}
        size={size}
      />
    </React.Fragment>
  )
}
